module.exports = __webpack_public_path__ + "img/info_gray.3dcf3680.svg";